<div class="vdo-sidebar">
  <div class="vdo-sidebar__container">
    <div class="vdo-sidebar__nav">
      <div class="vdo-sidebar__header">
        <button
          class="menu-item"
          id="vdo-sidebar-toggle-menu"
          vdoAutoTestId
          (click)="menuOpen()">
          <div class="menu-item__content menu-item__content--first">VDO Web</div>
          <div class="menu-item__icon">
            <vdo-icon [svgIcon]="isMenuOpen ? 'menu-open' : 'menu'" />
          </div>
        </button>
      </div>

      <ul class="menu-item-container">
        @for (menuItem of menuItems(); track menuItem) {
          @if (isMenuOpen) {
            <li class="menu-item-wrapper">
              <button *ngIf="menuItem?.children?.length || menuItem?.action; else menuNoneAction"
                      class="menu-item"
                      [id]="'vdo-sidebar-menu-' + menuItem.id"
                      vdoAutoTestId
                      matRipple
                      (click)="menuItemAction(menuItem);">
                @if (menuItem.icon) {
                  <div class="menu-item__icon">
                    <vdo-icon [svgIcon]="menuItem.icon" />
                  </div>
                }
                <div class="menu-item__content"
                     [ngStyle]="{ 'margin-left': !menuItem.icon ? '20px': ''}">
                  {{ menuItem.title | translate }}
                </div>
                <div class="menu-item__toggle-icon"
                     [ngClass]="{'menu-item__toggle-icon--expanded': menuItem.expanded}"
                     *ngIf="menuItem?.children?.length">
                  <vdo-icon svgIcon="arrow-left"></vdo-icon>
                </div>
              </button>
              <ng-template #menuNoneAction>
                <a class="menu-item"
                   [id]="'vdo-sidebar-link-' + menuItem.id"
                   [ngClass]="{'menu-item--active': menuItem.isActive}"
                   vdoAutoTestId
                   matRipple
                   [routerLink]="menuItem.link"
                   routerLinkActive="menu-item--active">
                  <div class="menu-item__icon">
                    <vdo-icon [svgIcon]="menuItem.icon" />
                  </div>
                  <div class="menu-item__content">
                    {{ menuItem.title | translate }}
                  </div>
                  <div class="menu-item__toggle-icon"
                       [ngClass]="{'menu-item__toggle-icon--expanded': menuItem.expanded}"
                       *ngIf="menuItem?.children?.length">
                    <vdo-icon>expand_more</vdo-icon>
                  </div>
                </a>
              </ng-template>
            </li>
          }
          @for (child of menuItem.children; track child) {
            <li class="submenu-item-wrapper"
                [ngClass]="{'submenu-item-wrapper--active': menuItem.expanded}">
              <a class="submenu-item"
                 [ngClass]="{'submenu-item--active': child.isActive}"
                 [id]="'vdo-sidebar-submenu-' + child.id"
                 vdoAutoTestId
                 matRipple
                 [matTooltip]="!isMenuOpen ? (child.title | translate) : ''"
                 matTooltipPosition="right"
                 [routerLink]="child.link">
                <div class="submenu-item__icon">
                  <vdo-icon [svgIcon]="child.icon" />
                </div>
                <div class="submenu-item__content">
                  {{ child.title | translate }}
                </div>
              </a>
            </li>
          }
        }
      </ul>
    </div>
  </div>
</div>
